<template>
    <div class="d-flex justify-content-center mt-4">
        <b-card border-variant="light" class="text-center" style="max-width: 60rem;">
            <h4>{{ title }}</h4>

            <div class="text-center text-xs">
                <slot name="textoVentas"></slot>
            </div>

            <hr/>

            <slot name="content">
                <b-alert show variant="warning">
                    Los datos no están disponibles en este momento. Recargue la página o consulte
                    con el servicio técnico. Muchas gracias.
                </b-alert>
            </slot>
        </b-card>
    </div>
</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                required: true,
            }
        }
    }
</script>